export const UPDATE_ITEM_STRINGS = {
    CANCEL_TEXT: 'Cancel',
    DELETE_TEXT: 'Delete',
    DELETE_HEADING: 'Delete Item',
    DELETE_TEXT_SUBHEADING1: 'Are you sure you want to delete this item? Deleting it will permanently remove it from both the <strong>campaign</strong> and this <strong>community</strong>. This action cannot be undone.',
    DELETE_TEXT_SUBHEADING2: 'Are you sure you want to delete this item? Deleting it will permanently remove it from this <strong>community</strong>. This action cannot be undone.',
    ADD_HEADING: 'Add Item',
    ADD_TEXT: 'Add',
    ADD_TEXT_SUBHEADING:
    'Your item is ready to go! 🚀 Start sharing it now to reach your audience and make an impact.',
    SAVE_TEXT: 'Save',
    SAVE_HEADING: 'Save Item',
    SAVE_TEXT_SUBHEADING: 'Are you sure you want to save these changes?',
    CANCEL_HEADING: 'Cancel Item',
    CANCEL_TEXT_SUBHEADING1:
      `Are you sure you want to cancel creating this item? Canceling now will discard all your progress on this item.`,
    CANCEL_TEXT_SUBHEADING2:
      `Are you sure you want to cancel editing this item? Canceling now will discard all your progress on this item.`,
    KEEP_EDITING_TEXT:'No, Keep Editing',
  } as const;
